(function () {
    var SEEN_KEY = 'posts-seen';
    var SEEN_CAP = 200;

    function readSeen() {
        try {
            var stored = JSON.parse(window.localStorage.getItem(SEEN_KEY));
            return Object.prototype.toString.call(stored) === '[object Array]' ? stored : [];
        } catch (error) {
            return [];
        }
    }

    function writeSeen(ids) {
        try {
            window.localStorage.setItem(SEEN_KEY, JSON.stringify(ids.slice(-SEEN_CAP)));
        } catch (error) {
            return;
        }
    }

    function markSeen(id) {
        if (!id) {
            return;
        }

        var ids = readSeen();

        if (ids.indexOf(id) >= 0) {
            return;
        }

        ids.push(id);
        writeSeen(ids);
    }

    (function postsSeen() {
        var feed = document.querySelector('[data-posts-feed]');

        if (!feed) {
            return;
        }

        var cards = Array.prototype.slice.call(feed.querySelectorAll('[data-post-id]'));

        if (!('IntersectionObserver' in window)) {
            cards.forEach(function (card) {
                markSeen(card.getAttribute('data-post-id'));
            });
            return;
        }

        var observer = new IntersectionObserver(function (entries) {
            entries.forEach(function (entry) {
                if (entry.intersectionRatio < 0.99) {
                    return;
                }
                var card = entry.target.closest('[data-post-id]');
                markSeen(card && card.getAttribute('data-post-id'));
                observer.unobserve(entry.target);
            });
        }, {threshold: 1});

        cards.forEach(function (card) {
            var title = card.querySelector('[data-feed-card-title]');
            observer.observe(title || card);
        });
    })();

    (function postPageSeen() {
        var post = document.querySelector('[data-post-seen]');

        if (post) {
            markSeen(post.getAttribute('data-post-seen'));
        }
    })();

    (function postsNudge() {
        var nudge = document.querySelector('[data-posts-nudge]');

        if (!nudge) {
            return;
        }

        var ids = (nudge.getAttribute('data-posts-ids') || '').split(',').filter(Boolean);

        if (!ids.length) {
            return;
        }

        var seen = readSeen();
        var hasUnseen = ids.some(function (id) {
            return seen.indexOf(id) < 0;
        });

        if (hasUnseen) {
            nudge.hidden = false;
        }
    })();
})();
